async function removeCustom(code){
  var cart = await fetch('/cart.js')
  .then(response => response.json())
  .then(data => { return data });
  if(cart){
    if(cart.items.length>0){
      let newCart = [];
      cart.items.forEach(c=>{
        let newItem = {
          id:c.variant_id,
          quantity:c.quantity,
          properties:{}
        };
        if(c.properties){
          if(c.properties._code != code){
            if(Object.keys(c.properties).length>0){
              if(c.properties.name)newItem.properties.name=c.properties.name;
              if(c.properties.artwork)newItem.properties.artwork=c.properties.artwork;
              if(c.properties.mon)newItem.properties.mon=c.properties.mon;
              if(c.properties.preview)newItem.properties.preview=c.properties.preview;
              if(c.properties.description)newItem.properties.description=c.properties.description;
              if(c.properties._extra)newItem.properties._extra=c.properties._extra;
              if(c.properties._code)newItem.properties._code=c.properties._code;
              if(c.properties._caseCode)newItem.properties._caseCode=c.properties._caseCode;
              if(c.properties._caseArt)newItem.properties._caseArt=c.properties._caseArt;
              if(c.properties._lawimg)newItem.properties._lawimg=c.properties._lawimg;
              if(c.properties._rawimg)newItem.properties._rawimg=c.properties._rawimg;
              if(c.properties._csimg)newItem.properties._csimg=c.properties._csimg;

              if(c.properties.owner)newItem.properties.owner=c.properties.owner;
              if(c.properties.leftShell)newItem.properties.leftShell=c.properties.leftShell;
              if(c.properties.rightShell)newItem.properties.rightShell=c.properties.rightShell;
              if(c.properties.leftPlate)newItem.properties.leftPlate=c.properties.leftPlate;
              if(c.properties.rightPlate)newItem.properties.rightPlate=c.properties.rightPlate;
              if(c.properties.leftArtwork)newItem.properties.leftArtwork=c.properties.leftArtwork;
              if(c.properties.rightArtwork)newItem.properties.rightArtwork=c.properties.rightArtwork;
              if(c.properties.cable)newItem.properties.cable=c.properties.cable;
              if(c.properties.case)newItem.properties.case=c.properties.case;
              if(c.properties._casePreview)newItem.properties._casePreview=c.properties._casePreview;
              if(c.properties._ownerEmail)newItem.properties._ownerEmail=c.properties._ownerEmail;
              if(c.properties._code)newItem.properties._code=c.properties._code;
              if(c.properties._isCase)newItem.properties._isCase=c.properties._isCase;
              if(c.properties._isMonitor)newItem.properties._isMonitor=c.properties._isMonitor;

            }
            newCart.push(newItem);
          }
        }else{
          newCart.push(newItem);
        }
      });
      $.ajax({
        url:'/cart/clear.js',
        type:'POST',
        dataType:'JSON',
        error:e=>console.log(e),
        success:r=>{
          if(newCart.length>0){
            
            $.ajax({
              url:'/cart/add.js',
              type:'POST',
              dataType:'JSON',
              data:{items: newCart.reverse()},
              error:e=>console.log(e),
              success:r=>location.href='/cart'
            });
          }else{
 	         location.href='/cart';
          }
        }
      });
    }
  }
}

async function removeCase(code){
  var cart = await fetch('/cart.js')
  .then(response => response.json())
  .then(data => { return data });
  if(cart){
    if(cart.items.length>0){
      let newCart = [];
      cart.items.forEach(c=>{
        let newItem = {
          id:c.variant_id,
          quantity:c.quantity,
          properties:{}
        };
        if(c.properties){
          if(c.properties._caseCode != code){
            if(Object.keys(c.properties).length>0){
              if(c.properties.name)newItem.properties.name=c.properties.name;
              if(c.properties.artwork)newItem.properties.artwork=c.properties.artwork;
              if(c.properties.mon)newItem.properties.mon=c.properties.mon;
              if(c.properties.preview)newItem.properties.preview=c.properties.preview;
              if(c.properties.description)newItem.properties.description=c.properties.description;
              if(c.properties._extra)newItem.properties._extra=c.properties._extra;
              if(c.properties._code)newItem.properties._code=c.properties._code;
              if(c.properties._caseCode)newItem.properties._caseCode=c.properties._caseCode;
              if(c.properties._caseArt)newItem.properties._caseArt=c.properties._caseArt;
              if(c.properties._lawimg)newItem.properties._lawimg=c.properties._lawimg;
              if(c.properties._rawimg)newItem.properties._rawimg=c.properties._rawimg;
              if(c.properties._csimg)newItem.properties._csimg=c.properties._csimg;

              if(c.properties.owner)newItem.properties.owner=c.properties.owner;
              if(c.properties.leftShell)newItem.properties.leftShell=c.properties.leftShell;
              if(c.properties.rightShell)newItem.properties.rightShell=c.properties.rightShell;
              if(c.properties.leftPlate)newItem.properties.leftPlate=c.properties.leftPlate;
              if(c.properties.rightPlate)newItem.properties.rightPlate=c.properties.rightPlate;
              if(c.properties.leftArtwork)newItem.properties.leftArtwork=c.properties.leftArtwork;
              if(c.properties.rightArtwork)newItem.properties.rightArtwork=c.properties.rightArtwork;
              if(c.properties.cable)newItem.properties.cable=c.properties.cable;
              if(c.properties.case)newItem.properties.case=c.properties.case;
              if(c.properties._casePreview)newItem.properties._casePreview=c.properties._casePreview;
              if(c.properties._ownerEmail)newItem.properties._ownerEmail=c.properties._ownerEmail;
              if(c.properties._code)newItem.properties._code=c.properties._code;
              if(c.properties._isCase)newItem.properties._isCase=c.properties._isCase;
              if(c.properties._isMonitor)newItem.properties._isMonitor=c.properties._isMonitor;
            }
            newCart.push(newItem);
          }
        }else{
          newCart.push(newItem);
        }
      });
      $.ajax({
        url:'/cart/clear.js',
        type:'POST',
        dataType:'JSON',
        error:e=>console.log(e),
        success:r=>{
          if(newCart.length>0){
            $.ajax({
              url:'/cart/add.js',
              type:'POST',
              dataType:'JSON',
              data:{items: newCart.reverse()},
              error:e=>console.log(e),
              success:r=>location.href='/cart'
            });
          }else{
 	         location.href='/cart';
          }
        }
      });
    }
  }
}